const MSK_FORMATTER = new Intl.DateTimeFormat('ru-RU', {
  timeZone: 'Europe/Moscow',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

function parseMSKDateParts(date) {
  const parts = MSK_FORMATTER.formatToParts(date);
  const datePart = Object.fromEntries(parts.filter((p) => p.type !== 'literal').map((p) => [p.type, p.value]));

  return {
    year: Number(datePart.year),
    month: Number(datePart.month),
    day: Number(datePart.day),
    hour: Number(datePart.hour),
    minute: Number(datePart.minute),
    second: Number(datePart.second),
  };
}

function getMSKTime() {
  const parts = parseMSKDateParts(new Date());
  return new Date(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
}

export function getTimeToNextSundayMSK() {
  const nowMSK = getMSKTime();
  const day = nowMSK.getDay();
  const nowHour = nowMSK.getHours();
  const nowMinute = nowMSK.getMinutes();
  const targetDay = 0;
  const targetHour = 23;
  const targetMinute = 59;

  let daysUntilTarget;

  if (day === targetDay) {
    if (nowHour < targetHour || (nowHour === targetHour && nowMinute <= targetMinute)) {
      daysUntilTarget = 0;
    } else {
      daysUntilTarget = 7;
    }
  } else if (day < targetDay) {
    daysUntilTarget = targetDay - day;
  } else {
    daysUntilTarget = 7 + targetDay - day;
  }

  const endDayMSK = new Date(nowMSK);
  endDayMSK.setDate(nowMSK.getDate() + daysUntilTarget);
  endDayMSK.setHours(targetHour, targetMinute, 59, 999);

  const diffTime = endDayMSK.getTime() - nowMSK.getTime();
  const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diffTime % (1000 * 60)) / 1000);

  return {
    endDayMSK,
    diffTime,
    days,
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  };
}
